import { auditReports } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { SelectElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { notificationPolicyMessages } from '../../../../../messages';

/**
 * Form segment that configures when deficiency notifications are sent to managers (notification policy).
 * Renders a single select for notificationSettings.policy; must be used inside the basic-info FormContainer.
 */
export function AodNotificationSettingsForm() {
  const { formatMessage } = useIntl();

  const policyOrder: (keyof typeof auditReports.NotificationSettingsPolicyEnum)[] = [
    'ALWAYS',
    'ORDER_END_ONLY',
    'NONE',
  ];
  const policyOptions = policyOrder.map((key) => ({
    id: auditReports.NotificationSettingsPolicyEnum[key],
    label: formatMessage(notificationPolicyMessages[key]),
  }));

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item xs={12} md={4} lg={3}>
        <SelectElement
          name="notificationSettings.policy"
          label={formatMessage(notificationPolicyMessages.label)}
          options={policyOptions}
          fullWidth
          required
        />
      </Grid>
    </Grid>
  );
}
